import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import SiteAccessGate from "@/components/SiteAccessGate";
import axios from "axios";
import HomePage from "@/pages/HomePage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminRichiestePage from "@/pages/admin/AdminRichiestePage";
// v1.73.0 — Nuova pagina unificata Richieste (aggregation cross-ramo)
import CRMRichiesteUnifiedPage from "@/pages/admin/CRMRichiesteUnifiedPage";
import AdminNotiziePage from "@/pages/admin/AdminNotiziePage";
import AdminNotizieBadgeFloating from "@/components/admin/AdminNotizieBadgeFloating";
import GlobalErrorBoundary from "@/components/GlobalErrorBoundary";
import AdminClienteUnificatoPage from "@/pages/admin/AdminClienteUnificatoPage";
import AdminAuditLogPage from "@/pages/admin/AdminAuditLogPage";
import AdminKpiPage from "@/pages/admin/AdminKpiPage";
// ITER 70 — Convenzioni CRM Dashboard gerarchica
import AdminConvenzioniCrmPage from "@/pages/admin/AdminConvenzioniCrmPage";
// FASE L1 — Cockpit Operatore (home unificata)
import AdminCockpitPage from "@/pages/admin/AdminCockpitPage";
// FASE H — RBAC, provisioning, security alerts, team analytics
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import AdminSecurityAlertsPage from "@/pages/admin/AdminSecurityAlertsPage";
import AdminTeamAnalyticsPage from "@/pages/admin/AdminTeamAnalyticsPage";
import AdminTeamPage from "@/pages/admin/AdminTeamPage";
import AdminComplianceDuplicatiPage from "@/pages/admin/AdminComplianceDuplicatiPage";
import ViaggioPage from "@/pages/ViaggioPage";
// ROLLBACK TASK 8 (v1.2.5): ripristino questionari legacy come pagine attive
import EconomicoGiuridicoPage from "@/pages/EconomicoGiuridicoPage";
import AreaTecnicaPage from "@/pages/AreaTecnicaPage";
import DroniPage from "@/pages/DroniPage";
import StrutturaSanitariaPage from "@/pages/StrutturaSanitariaPage";
import QuotatorePage from "@/pages/QuotatorePage";
import NoleggoPage from "@/pages/NoleggoPage";
import FeatureFlagGate from "@/components/FeatureFlagGate";
import CarDetailPage from "@/pages/CarDetailPage";
import FunnelPage from "@/pages/FunnelPage";
import ConsulenzaPage from "@/pages/ConsulenzaPage";
import ConsulenzaConfermaPage from "@/pages/ConsulenzaConfermaPage";
import PreventivoAutoPage from "@/pages/PreventivoAutoPage";
import PreventivoAutoConfermaPage from "@/pages/PreventivoAutoConfermaPage";
import EventoLandingPage from "@/pages/EventoLandingPage";
import EventoConfermaPage from "@/pages/EventoConfermaPage";
import EventiListPage from "@/pages/EventiListPage";
// HOTFIX 27-lug — 5 wizard orfani rimossi (dead code, sostituiti da schema-driven
// /questionario/casa|vita|salute|viaggi|aziende):
//   PreventivoCasaPage, PreventivoVitaPage, PreventivoSalutePage,
//   PreventivoViaggioPage, PreventivoAziendaPage
import PreventivoFamigliaConfermaPage from "@/pages/PreventivoFamigliaConfermaPage";
import LegalPolicyPage from "@/pages/LegalPolicyPage";
import CompagniePage from "@/pages/CompagniePage";
// ROLLBACK TASK 8 (Fase 4.2.5): PreventivoRcSanitaria, PreventivoRcProfessionale,
// PreventivoInfortuni e PreventivoNoleggio non sono più routate.
// FASE D (20-lug-2026): pagine .jsx corrispondenti eliminate perché orfane;
// le route sopra restano come redirect verso i wizard originali.
import ProfessioniPage from "@/pages/ProfessioniPage";
import FamigliaPage from "@/pages/FamigliaPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import WhistleblowingPage from "@/pages/WhistleblowingPage";
import WhistleblowingRegolamentoPage from "@/pages/WhistleblowingRegolamentoPage";
import NotizieAssicurativePage from "@/pages/NotizieAssicurativePage";
import NovitaNoleggioPage from "@/pages/NovitaNoleggioPage";
import NovitaNoleggioDetailPage from "@/pages/NovitaNoleggioDetailPage";
import ScrollToTop from "@/components/ScrollToTop";
import PraticaNoleggioPage from "@/pages/PraticaNoleggioPage";
import PraticaArvalPlaceholderPage from "@/pages/PraticaArvalPlaceholderPage";
import PraticaCreditoPage from "@/pages/PraticaCreditoPage";
import VerificaModuliPage from "@/pages/VerificaModuliPage";
import PraticaCreditoCompletataPage from "@/pages/PraticaCreditoCompletataPage";
import PagaPolizzaPage from "@/pages/PagaPolizzaPage";
import PagamentoEsitoPage from "@/pages/PagamentoEsitoPage";
import PagamentoAnnullatoPage from "@/pages/PagamentoAnnullatoPage";
import TermsOfUsePage from "@/pages/TermsOfUsePage";
import ReclamiPage from "@/pages/ReclamiPage";
import ChiSiamoPage from "@/pages/ChiSiamoPage";
import SedePage from "@/pages/SedePage";
import ConvenzioniPage from "@/pages/ConvenzioniPage";
import DichiarazioneAccessibilitaPage from "@/pages/DichiarazioneAccessibilitaPage";
import NewsletterActionPage from "@/pages/NewsletterActionPage";
import FondiPensionePage from "@/pages/FondiPensionePage";
import FondiPensioneQuestionarioPage from "@/pages/FondiPensioneQuestionarioPage";
import DpoInfoPage from "@/pages/DpoInfoPage";
import AziendePage from "@/pages/AziendePage";
import CatNatInfoPage from "@/pages/CatNatInfoPage";
import QuotatoreCatNatPage from "@/pages/QuotatoreCatNatPage";
import QuestionarioSanitarioPage from "@/pages/QuestionarioSanitarioPage";
import QuestionarioProfessioniSanitariePage from "@/pages/QuestionarioProfessioniSanitariePage";
import PolizzaSalutePage from "@/pages/PolizzaSalutePage";
import StimaCostoRicostruzionePage from "@/pages/StimaCostoRicostruzionePage";
import PolizzaCommercioPage from "@/pages/PolizzaCommercioPage";
import QuoterPublicPage from "@/pages/public/QuoterPublicPage";
import DOPublicFormPage from "@/pages/public/DOPublicFormPage";
import CyberWizard from "@/pages/public/cyber/CyberWizard";
import FineArtsWizard from "@/pages/public/fine_arts/FineArtsWizard";
import CookieBanner, { PrivacySettingsButton } from "@/components/CookieBanner";
import CommandKProvider from "@/components/admin/CommandKProvider";
import PageviewTracker from "@/components/PageviewTracker";
// v1.14.59 — Rimosso SmartLeadPopup (widget popup exit-intent). I lead storici
// restano accessibili da Richieste Unificate (source=lead-popup).
// import SmartLeadPopup from "@/components/SmartLeadPopup";
import SaveTheDateBanner from "@/components/SaveTheDateBanner";
import LegalDocPage from "@/pages/legal/LegalDocPage";
import AdminCompliancePage from "@/pages/admin/AdminCompliancePage";
import PraticheDOPage from "@/pages/admin/PraticheDOPage";
import PraticheCyberPage from "@/pages/admin/PraticheCyberPage";
import PraticheFineArtsPage from "@/pages/admin/PraticheFineArtsPage";
import AdminFeatureFlagsPage from "@/pages/admin/AdminFeatureFlagsPage";
import AdminAISiteDoctorPage from "@/pages/admin/AdminAISiteDoctorPage";
import AdminAISiteDoctorApplicationsPage from "@/pages/admin/AdminAISiteDoctorApplicationsPage";
import AdminSecurityPage from "@/pages/admin/AdminSecurityPage";
import AdminGdprRequestsPage from "@/pages/admin/AdminGdprRequestsPage";
import AdminComplianceFindingsPage from "@/pages/admin/AdminComplianceFindingsPage";
import AdminDBBackupPage from "@/pages/admin/AdminDBBackupPage";
import TrasparenzaPage from "@/pages/TrasparenzaPage";

// v1.14.70.0 — AI Site Doctor (FASE 7A foundation)
import AISiteDoctorBoundary from "@/components/AISiteDoctorBoundary";
import { installAISiteDoctor } from "@/services/aiSiteDoctorClient";

// TASK 3 — FASE 3.2: Area Cliente self-service
import { ClientAuthProvider } from "@/contexts/ClientAuthContext";
import AuthModalsHost from "@/components/auth/AuthModalsHost";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

// v1.70 (UX fix) — redirect /contatti a /consulenza preservando il querystring intatto
function ContattiRedirect() {
  const location = useLocation();
  return <Navigate to={`/consulenza${location.search || ""}`} replace />;
}


function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#FCFCFA] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#163321] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

function PublicOverlays() {
  const { pathname } = useLocation();
  // Non mostrare su area admin
  if (pathname.startsWith("/admin")) return null;

  // Context-aware message per WhatsApp
  let ctx = "default";
  if (pathname.startsWith("/preventivo-auto") || pathname.includes("auto")) ctx = "auto";
  else if (pathname.includes("viaggio")) ctx = "viaggio";
  else if (pathname.startsWith("/noleggio")) ctx = "noleggio";
  else if (pathname.startsWith("/consulenza")) ctx = "consulenza";
  else if (pathname.includes("famiglia") || pathname.includes("casa")) ctx = "casa";

  return (
    <>
      <WhatsAppFloat context={ctx} />
      <AccessibilityWidget />
      <PageviewTracker />
      {/* v1.14.59 — Rimosso <SmartLeadPopup /> exit-intent widget */}
    </>
  );
}

function GatedRoutes({ onLogin }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isClientArea = pathname.startsWith("/area-cliente") || pathname.startsWith("/area-personale");
  // v1.14.64.0 — /do landing pubblica D&O bypassa SiteAccessGate (come /q/*)
  const isQuoterPublic = pathname.startsWith("/q/") || pathname === "/do" || pathname === "/cyber" || pathname === "/fine-arts";

  // FASE 4.2 — Area Cliente UNIFICATA nel sito pubblico.
  // Tutte le vecchie route /area-cliente/* redirectano alla home con stato
  // modal/drawer aperto. I file componente restano su disco (non eliminati).
  if (isClientArea) {
    const map = {
      "/area-cliente": "/",
      "/area-cliente/registrazione-completa": "/?login=1",
      "/area-cliente/login": "/?login=1",
      "/area-cliente/auth": "/?login=1",
      "/area-cliente/register": "/?login=1",
      "/area-cliente/otp-verify": "/?login=1",
      "/area-cliente/dashboard": "/?drawer=dashboard",
      "/area-cliente/profili": "/?drawer=profilo",
      "/area-cliente/profili/nuovo": "/?drawer=profilo",
      "/area-cliente/prodotti": "/?drawer=preventivi",
      "/area-cliente/richieste": "/?drawer=preventivi",
      "/area-cliente/polizze": "/?drawer=polizze",
      "/area-cliente/documenti": "/?drawer=documenti",
      "/area-cliente/notifiche": "/?drawer=notifiche",
      "/area-cliente/familiari": "/?drawer=familiari",
      "/area-cliente/password-reset-request": "/?login=1",
      "/area-cliente/password-reset-confirm": "/?login=1",
      // v1.67 FASE 3 — Privacy dashboard cliente
      "/area-personale/privacy": "/?drawer=privacy",
      "/area-cliente/privacy": "/?drawer=privacy",
    };
    // match esatto, poi prefisso fallback → /
    const target = map[pathname] || "/";
    return <Navigate to={target} replace />;
  }

  const publicRoutes = (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/sedi/:slug" element={<SedePage />} />
      <Route path="/convenzioni" element={<ConvenzioniPage />} />
      {/* Questionari legacy ATTIVI (ripristinati dopo rollback TASK 8) */}
      <Route path="/questionario/professionisanitarie" element={<QuestionarioProfessioniSanitariePage />} />
      <Route path="/questionario/professioni-sanitarie" element={<Navigate to="/questionario/professionisanitarie" replace />} />
      <Route path="/polizza-salute" element={<PolizzaSalutePage />} />
      <Route path="/stima-costo-ricostruzione" element={<StimaCostoRicostruzionePage />} />
      <Route path="/polizza-commercio" element={<PolizzaCommercioPage />} />
      <Route path="/aziende/commercio" element={<PolizzaCommercioPage />} />
      <Route path="/salute/realmenteinsalute" element={<Navigate to="/polizza-salute" replace />} />
      <Route path="/questionario/struttura-sanitaria" element={<StrutturaSanitariaPage />} />
      <Route path="/quotatore" element={<QuotatorePage />} />
      <Route path="/noleggio" element={<FeatureFlagGate flag="noleggio_enabled"><NoleggoPage /></FeatureFlagGate>} />
      <Route path="/noleggio/novita" element={<FeatureFlagGate flag="noleggio_enabled"><NovitaNoleggioPage /></FeatureFlagGate>} />
      <Route path="/noleggio/novita/:slug" element={<FeatureFlagGate flag="noleggio_enabled"><NovitaNoleggioDetailPage /></FeatureFlagGate>} />
      <Route path="/noleggio/:id" element={<FeatureFlagGate flag="noleggio_enabled"><CarDetailPage /></FeatureFlagGate>} />
      <Route path="/scopri-polizze" element={<FunnelPage />} />
      <Route path="/consulenza" element={<ConsulenzaPage />} />
      <Route path="/consulenza/conferma" element={<ConsulenzaConfermaPage />} />
      <Route path="/preventivo-auto" element={<PreventivoAutoPage />} />
      <Route path="/preventivo-auto/conferma" element={<PreventivoAutoConfermaPage />} />
      <Route path="/eventi" element={<EventiListPage />} />
      <Route path="/eventi/:slug" element={<EventoLandingPage />} />
      <Route path="/eventi/:slug/conferma" element={<EventoConfermaPage />} />
      {/* FASE 4.2.11 — ROLLBACK CONTENUTI: i 5 wizard TASK 8 (casa/vita/salute/
          viaggio/azienda) redirezionano ai questionari legacy originali.
          Il contenuto è quello dei questionari assicurativi cartacei scansionati
          dal cliente — NON modificabile. I file PreventivoCasaPage.jsx ecc.
          restano su disco (orphan, non importati). */}
      <Route path="/preventivo-casa" element={<Navigate to="/questionario/casa" replace />} />
      <Route path="/preventivo-casa/conferma" element={<PreventivoFamigliaConfermaPage />} />
      <Route path="/preventivo-vita" element={<Navigate to="/questionario/vita" replace />} />
      <Route path="/preventivo-vita/conferma" element={<PreventivoFamigliaConfermaPage />} />
      <Route path="/preventivo-salute" element={<Navigate to="/questionario/sanitario" replace />} />
      <Route path="/preventivo-salute/conferma" element={<PreventivoFamigliaConfermaPage />} />
      {/* Questionari legacy ATTIVI sui contenuti originali.
          FIX FASE 4.2.11b: rimosse le route statiche casa/vita/aziende: in React
          Router v6 oscuravano il catchall `/questionario/:type` (riga ~266) e
          rendevano `useParams().type` undefined → pagina vuota.
          Ora casa/vita/aziende sono gestiti dal catchall che passa `type` come
          parametro a QuestionnairePage (CONFIGS = {auto,casa,vita,aziende}).
          /sanitario usa il componente dedicato QuestionarioSanitarioPage. */}
      <Route path="/questionario/sanitario" element={<QuestionarioSanitarioPage />} />
      <Route path="/questionario/salute" element={<Navigate to="/questionario/sanitario" replace />} />
      {/* /preventivo-viaggio: nessun questionario legacy esisteva per viaggio
          (non era nei questionari scansionati e non è in CONFIGS di
          QuestionnairePage). Redirect a contatti. */}
      <Route path="/preventivo-viaggio" element={<Navigate to="/questionario/viaggi" replace />} />
      <Route path="/preventivo-viaggio/conferma" element={<PreventivoFamigliaConfermaPage />} />
      <Route path="/questionario/viaggio" element={<Navigate to="/questionario/viaggi" replace />} />
      <Route path="/preventivo-azienda" element={<Navigate to="/questionario/aziende" replace />} />
      <Route path="/preventivo-azienda/conferma" element={<PreventivoFamigliaConfermaPage />} />
      <Route path="/questionario/auto" element={<Navigate to="/preventivo-auto" replace />} />
      <Route path="/questionario/economico-giuridico" element={<EconomicoGiuridicoPage />} />
      <Route path="/questionario/area-tecnica" element={<AreaTecnicaPage />} />
      <Route path="/questionario/droni" element={<DroniPage />} />
      <Route path="/professioni" element={<ProfessioniPage />} />
      <Route path="/famiglia" element={<FamigliaPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      {/* v1.14.83.0 FASE 8.10 — Pagina Trasparenza broker IVASS Reg. 40/2018 */}
      <Route path="/trasparenza" element={<TrasparenzaPage />} />
      <Route path="/privacy/dpo" element={<DpoInfoPage />} />
      <Route path="/dpo" element={<DpoInfoPage />} />
      {/* GDPR — Informative legali linkabili dai consensi (TASK consent links) */}
      <Route path="/legal/:slug" element={<LegalPolicyPage />} />
      {/* FASE 8.4 — Compagnie partner (rimossa da home, link via footer) */}
      <Route path="/compagnie" element={<CompagniePage />} />
      {/* TASK 8 ROLLBACK COMPLETO (Fase 4.2.5):
          - RC Sanitaria/Professionale → questionari legacy
          - Noleggio → pagina catalogo originale /noleggio (Ayvens scraping + News)
          - Infortuni → wizard Salute legacy
          Nessuno dei wizard TASK 8 era originale del codebase del cliente. */}
      <Route path="/preventivo-noleggio" element={<Navigate to="/noleggio" replace />} />
      <Route path="/preventivo-infortuni" element={<Navigate to="/preventivo-salute" replace />} />
      {/* Redirect inverso: nuovi URL → legacy attivi (SEO + link esterni) */}
      <Route path="/preventivo-rc-sanitaria" element={<Navigate to="/questionario/professionisanitarie" replace />} />
      <Route path="/preventivo-rc-professionale" element={<Navigate to="/questionario/economico-giuridico" replace />} />
      <Route path="/preventivo-famiglia/conferma" element={<PreventivoFamigliaConfermaPage />} />
      <Route path="/aziende" element={<AziendePage />} />
      <Route path="/aziende/catnat" element={<CatNatInfoPage />} />
      <Route path="/aziende/catnat/quotatore" element={<QuotatoreCatNatPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      <Route path="/whistleblowing" element={<WhistleblowingPage />} />
      <Route path="/whistleblowing/regolamento" element={<WhistleblowingRegolamentoPage />} />
      <Route path="/notizie-assicurative" element={<NotizieAssicurativePage />} />
      <Route path="/noleggio/pratica/:carId" element={<PraticaNoleggioPage />} />
      <Route path="/noleggio/pratica-arval/:carId" element={<PraticaArvalPlaceholderPage />} />
      <Route path="/credito/pratica" element={<PraticaCreditoPage />} />
      <Route path="/credito/pratica/:praticaId/verifica" element={<VerificaModuliPage />} />
      <Route path="/credito/pratica/:praticaId/completata" element={<PraticaCreditoCompletataPage />} />
      <Route path="/paga" element={<PagaPolizzaPage />} />
      <Route path="/pagamento/esito" element={<PagamentoEsitoPage />} />
      <Route path="/pagamento/annullato" element={<PagamentoAnnullatoPage />} />
      <Route path="/termini" element={<TermsOfUsePage />} />
      <Route path="/termini-e-condizioni" element={<TermsOfUsePage />} />
      <Route path="/reclami" element={<ReclamiPage />} />
      <Route path="/chi-siamo" element={<ChiSiamoPage />} />
      <Route path="/accessibilita" element={<DichiarazioneAccessibilitaPage />} />
      <Route path="/dichiarazione-accessibilita" element={<DichiarazioneAccessibilitaPage />} />
      <Route path="/newsletter/conferma/:token" element={<NewsletterActionPage action="conferma" />} />
      <Route path="/newsletter/disiscrivi/:token" element={<NewsletterActionPage action="disiscrivi" />} />

      {/* Fondi Pensione — PIP Reale Mutua (Classic + Premium) */}
      <Route path="/fondi-pensione" element={<FondiPensionePage />} />
      <Route path="/fondi-pensione/questionario" element={<FondiPensioneQuestionarioPage />} />

      {/* HOTFIX 27-lug — redirect PRIMA del catch-all /questionario/:type */}
      <Route path="/questionario/fine-arts" element={<Navigate to="/fine-arts" replace />} />
      <Route path="/questionario/:type" element={<QuestionnairePage />} />
      {/* v1.70 (UX fix) — /contatti era linkato ma senza route: redirect a /consulenza preservando il querystring */}
      <Route path="/contatti" element={<ContattiRedirect />} />
      <Route path="/conferma" element={<ConfirmationPage />} />
    </Routes>
  );

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLoginPage onLogin={onLogin} />} />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute><AdminDashboardPage /></ProtectedRoute>
        } />
        {/* HOTFIX 27-lug — Route legacy come ALIAS della Cockpit (non redirect Navigate)
             Zero jarring UX per bookmark utente + no schermata bianca.
             Le vecchie pagine restano accessibili via /admin/richieste/legacy e
             /admin/convenzioni/crm/legacy per debug/rollback.
             (Precedentemente Fase L2.3 usava <Navigate>, ma alcuni utenti riportavano
              percezione di "backend rotto" quando aprivano vecchie URL.) */}
        {/* v1.73.0 (feb-2026) — Richieste Unificate:
             /admin/richieste          → nuova CRMRichiesteUnifiedPage (8 filtri pro)
             /admin/richieste/cockpit  → AdminCockpitPage (KPI + stream + kanban)
             /admin/richieste/legacy   → AdminRichiestePage (old aggregation UI) */}
        <Route path="/admin/richieste" element={
          <ProtectedRoute><CRMRichiesteUnifiedPage /></ProtectedRoute>
        } />
        <Route path="/admin/richieste/cockpit" element={
          <ProtectedRoute><AdminCockpitPage /></ProtectedRoute>
        } />
        <Route path="/admin/richieste/legacy" element={
          <ProtectedRoute><AdminRichiestePage /></ProtectedRoute>
        } />
        <Route path="/admin/clienti/:cliente_id" element={
          <ProtectedRoute><AdminClienteUnificatoPage /></ProtectedRoute>
        } />
        {/* MINI-FASE B.1 — Audit log export PII */}
        <Route path="/admin/audit-log" element={
          <ProtectedRoute><AdminAuditLogPage /></ProtectedRoute>
        } />
        {/* FASE G — KPI dashboard cross-ramo */}
        <Route path="/admin/kpi" element={
          <ProtectedRoute><AdminKpiPage /></ProtectedRoute>
        } />
        {/* HOTFIX — Route legacy Convenzioni CRM come alias Cockpit */}
        <Route path="/admin/convenzioni/crm" element={
          <ProtectedRoute><AdminCockpitPage /></ProtectedRoute>
        } />
        <Route path="/admin/convenzioni/crm/legacy" element={
          <ProtectedRoute><AdminConvenzioniCrmPage /></ProtectedRoute>
        } />
        <Route path="/admin/convenzioni" element={
          <ProtectedRoute><AdminCockpitPage /></ProtectedRoute>
        } />
        {/* FASE L1 — Cockpit Operatore (home unificata) */}
        <Route path="/admin/cockpit" element={
          <ProtectedRoute><AdminCockpitPage /></ProtectedRoute>
        } />
        {/* FASE H — RBAC + provisioning + antifrode + team analytics (stub) */}
        <Route path="/admin/utenze" element={
          <ProtectedRoute><AdminUsersPage /></ProtectedRoute>
        } />
        {/* feb-2026 Step 5 — Workflow editoriale notizie assicurative */}
        <Route path="/admin/notizie" element={
          <ProtectedRoute><AdminNotiziePage /></ProtectedRoute>
        } />
        <Route path="/admin/security/alerts" element={
          <ProtectedRoute><AdminSecurityAlertsPage /></ProtectedRoute>
        } />
        <Route path="/admin/analytics/team" element={
          <ProtectedRoute><AdminTeamAnalyticsPage /></ProtectedRoute>
        } />
        <Route path="/admin/team" element={
          <ProtectedRoute><AdminTeamPage /></ProtectedRoute>
        } />
        <Route path="/admin/crm/multi/compliance" element={
          <ProtectedRoute><AdminComplianceDuplicatiPage /></ProtectedRoute>
        } />
        {/* FASE 4.2.11.5 — Admin Compliance Hub (IVASS / AML / DORA) */}
        <Route path="/admin/compliance" element={
          <ProtectedRoute><AdminCompliancePage /></ProtectedRoute>
        } />
        {/* v1.14.67.1 — Admin Pratiche D&O (storage + download AIG/Reale/Lloyd's/ZIP + rigenera) */}
        <Route path="/admin/pratiche-do" element={
          <ProtectedRoute><PraticheDOPage /></ProtectedRoute>
        } />
        {/* FASE 7.6 — Admin Pratiche Cyber (gemella D&O; endpoint /api/admin/cyber/pratiche) */}
        <Route path="/admin/pratiche-cyber" element={
          <ProtectedRoute><PraticheCyberPage /></ProtectedRoute>
        } />
        {/* FASE 9.5 — Admin Pratiche Fine Arts Lloyd's */}
        <Route path="/admin/pratiche-fine-arts" element={
          <ProtectedRoute><PraticheFineArtsPage /></ProtectedRoute>
        } />
        {/* v1.67 FASE 3 — Admin Privacy GDPR Requests */}
        <Route path="/admin/privacy/gdpr-requests" element={
          <ProtectedRoute><AdminGdprRequestsPage /></ProtectedRoute>
        } />
        {/* FASE 10 — Admin Feature Flags (Noleggio suspend + future toggles) */}
        <Route path="/admin/feature-flags" element={
          <ProtectedRoute><AdminFeatureFlagsPage /></ProtectedRoute>
        } />
        {/* v1.14.71.0 — FASE 7B: Admin AI Site Doctor Dashboard */}
        <Route path="/admin/ai-site-doctor" element={
          <ProtectedRoute><AdminAISiteDoctorPage /></ProtectedRoute>
        } />
        {/* v1.14.74.0 — FASE 7E: Applications audit page */}
        <Route path="/admin/ai-site-doctor/applications" element={
          <ProtectedRoute><AdminAISiteDoctorApplicationsPage /></ProtectedRoute>
        } />
        {/* v1.14.78.0 — FASE 8.1: Admin Security (MFA + IP Allowlist + Access Log) */}
        <Route path="/admin/security" element={
          <ProtectedRoute><AdminSecurityPage /></ProtectedRoute>
        } />
        {/* v1.14.78.0 — FASE 8.5: Compliance Findings Dashboard */}
        <Route path="/admin/compliance/findings" element={
          <ProtectedRoute><AdminComplianceFindingsPage /></ProtectedRoute>
        } />
        {/* v1.14.83.0 — DB Backup admin-authenticated */}
        <Route path="/admin/db-backup" element={
          <ProtectedRoute><AdminDBBackupPage /></ProtectedRoute>
        } />
        <Route path="/admin/compliance/aml" element={
          <ProtectedRoute><AdminCompliancePage /></ProtectedRoute>
        } />
        <Route path="/admin/compliance/tech-providers" element={
          <ProtectedRoute><AdminCompliancePage /></ProtectedRoute>
        } />
        <Route path="/admin/compliance/funzione-aml" element={
          <ProtectedRoute><AdminCompliancePage /></ProtectedRoute>
        } />
      </Routes>
    );
  }

  // v1.14.61.0 F4 — landing pubblica Quoter (bypassa SiteAccessGate,
  // accesso solo via token URL-safe generato dal broker).
  if (isQuoterPublic) {
    return (
      <Routes>
        <Route path="/do" element={<DOPublicFormPage openMode={true} />} />
        <Route path="/q/do/:token" element={<DOPublicFormPage />} />
        <Route path="/cyber" element={<CyberWizard />} />
        <Route path="/fine-arts" element={<FineArtsWizard />} />
        {/* redirect già gestito prima del catch-all questionario:type */}
        <Route path="/q/:token" element={<QuoterPublicPage />} />
      </Routes>
    );
  }

  return <SiteAccessGate><SaveTheDateBanner />{publicRoutes}</SiteAccessGate>;
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // v1.14.70.0 — AI Site Doctor: installa collector errori (window.onerror,
    // console.error, fetch wrapper, DOM red message observer, click/pageview tracker)
    try { installAISiteDoctor(); } catch (_) { /* never block app */ }

    // Analytics Plausible (privacy-friendly, GDPR-safe, no-cookie).
    // Config via REACT_APP_PLAUSIBLE_DOMAIN — se vuoto, log-only in dev.
    import("@/lib/analytics").then(({ initPlausible }) => {
      try { initPlausible(); } catch (_) { /* never block app */ }
    }).catch(() => {});

    const checkAuth = async () => {
      try {
        const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
        setUser(data);
      } catch (err) {
        console.error("Auth check failed:", err.message);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogin = (userData) => setUser(userData);
  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (err) {
      console.error("Logout error:", err.message);
    }
    setUser(null);
  };

  return (
    <AISiteDoctorBoundary>
      <AuthContext.Provider value={{ user, loading, handleLogin, handleLogout }}>
        <ClientAuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <GlobalErrorBoundary>
              <AuthModalsHost>
                <GatedRoutes onLogin={handleLogin} />
                <Toaster position="top-right" />
                <CookieBanner />
                <PrivacySettingsButton />
                <PublicOverlays />
                <CommandKProvider />
                <AdminNotizieBadgeFloating />
              </AuthModalsHost>
            </GlobalErrorBoundary>
          </BrowserRouter>
        </ClientAuthProvider>
      </AuthContext.Provider>
    </AISiteDoctorBoundary>
  );
}

export default App;
